import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';

export default function NewsletterProgressBlock({ progress, log, doneKey }) {
  if (!progress && (!log || log.length === 0)) return null;
  const hasFailures = progress && (progress.failed || 0) > 0;
  return (
    <div style={{ marginTop: 16, padding: 14, borderRadius: 8, background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}>
      {progress && (
        <div style={{ fontSize: 13, color: 'var(--text)', marginBottom: log.length ? 10 : 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          {hasFailures
            ? <AlertCircle size={14} style={{ color: '#f59e0b' }} />
            : <CheckCircle2 size={14} style={{ color: '#22c55e' }} />}
          <span>
            {progress[doneKey] ?? 0}{progress.total ? ` / ${progress.total}` : ''}
            {hasFailures ? ` (${progress.failed} misslyckade)` : ''}
          </span>
        </div>
      )}
      {log.length > 0 && (
        <div style={{ fontFamily: 'ui-monospace, monospace', fontSize: 11, color: 'var(--muted)', maxHeight: 140, overflow: 'auto' }}>
          {log.map((line, i) => <div key={i}>{line}</div>)}
        </div>
      )}
    </div>
  );
}

export async function consumeSSE(response, onEvent) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf('\n\n')) !== -1) {
      const block = buf.slice(0, idx);
      buf = buf.slice(idx + 2);
      const dataLine = block.split('\n').find(l => l.startsWith('data:'));
      if (dataLine) {
        try { onEvent(JSON.parse(dataLine.slice(5).trim())); } catch (e) { /* skip malformed */ }
      }
    }
  }
}
